import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { RefreshCw, Radio } from "lucide-react";
import { toast } from "sonner";

const SOURCES = [["ticketmaster", "Ticketmaster"], ["skiddle", "Skiddle"]];

export const EventImportPanel = () => {
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const { data } = useQuery({ queryKey: ["event-import"], queryFn: async () => (await api.get("/admin/events/import")).data });
  const anyKey = data && (data.keys.ticketmaster || data.keys.skiddle);

  const runNow = async () => {
    setBusy(true);
    try {
      const r = (await api.post("/admin/events/import")).data;
      toast.success(`Imported: ${r.added} new, ${r.updated} refreshed`);
      ["event-import", "admin-events", "admin-stats"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
    } catch (e) { toast.error(apiError(e.response?.data?.detail) || "Import failed"); }
    setBusy(false);
  };

  return (
    <div data-testid="event-import-panel" className="glass rounded-2xl p-5 mb-5 flex flex-wrap items-center gap-4 justify-between">
      <div>
        <p className="font-display font-bold flex items-center gap-2"><Radio className="h-4 w-4 text-amber-400" /> Auto event listings</p>
        <p className="text-xs text-emerald-100/60 mt-1">Real events within each launch area pulled in every morning at 5am (London).</p>
        <div className="flex flex-wrap gap-2 mt-3">
          {SOURCES.map(([k, label]) => (
            <span key={k} data-testid={`import-source-${k}`}
              className={`text-[11px] px-2.5 py-1 rounded-full border ${data?.keys[k] ? "border-emerald-400/40 text-emerald-200" : "border-white/15 text-white/50"}`}>
              {label}: {data?.keys[k] ? (data?.last_run?.sources?.[k] || "ready") : "key needed"}
            </span>
          ))}
          <span data-testid="import-count" className="text-[11px] px-2.5 py-1 rounded-full border border-white/15 text-white/70">
            {data?.imported_count ?? 0} live listings
          </span>
        </div>
        {data?.last_run && <p data-testid="import-last-run" className="text-[11px] text-white/40 mt-2">Last run {new Date(data.last_run.at).toLocaleString()}</p>}
      </div>
      <Button data-testid="import-now-btn" disabled={!anyKey || busy} onClick={runNow} className="btn-gold rounded-full">
        <RefreshCw className={`h-4 w-4 mr-2 ${busy ? "animate-spin" : ""}`} /> {anyKey ? "Import now" : "Add a key to start"}
      </Button>
    </div>
  );
};
